import { useTranslation } from "react-i18next"

export function IntroPage({ goToNextPage }: { goToNextPage: () => void }) {
  const { t } = useTranslation(["btwtool", "common"])

  return (
    <div>
      { false && <h1>{t("intro__title")}</h1>}
      { false && <h2>{t("intro__slug")}</h2>}
      <p>{t("intro__description")}</p>
      <button className="button-primary" onClick={goToNextPage}>{t("button__intro", { ns: "common" })}</button>
    </div>
  )
}